<template>
  <div class="modal fade fixed-right modal-new-graduate" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-vertical" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Create new graduate user</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <p>The user will be created and added to the graduate program. The user will be created as inactive with their username automatically generated by the system.</p>

          <div class="decorative-divider"></div>

          <div class="form-group">
            <p class="control-label">First Name *</p>
            <input v-model="firstName" v-validate="'required'" name="first_name" data-vv-as="first name" type="text" class="form-control">

            <help-block field="first_name"/>
          </div><!-- /.form-group -->

          <div class="form-group">
            <p class="control-label">Last Name *</p>
            <input v-model="lastName" v-validate="'required'" name="last_name" data-vv-as="last name" type="text" class="form-control">

            <help-block field="last_name"/>
          </div><!-- /.form-group -->

          <div class="form-group">
            <p class="control-label">Candidate ID</p>
            <input v-model="candidateId" name="candidate_id" data-vv-as="candidate id" type="text" class="form-control">

            <help-block field="candidate_id"/>
          </div><!-- /.form-group -->

          <div class="form-group">
            <p class="control-label">Backup Email Address *</p>
            <input v-model="email" v-validate="'required|email'" name="email" type="email" class="form-control">

            <help-block field="email"/>
          </div><!-- /.form-group -->

          <div class="form-group">
            <p class="control-label">GEN Number</p>
            <input v-model="gen" name="gen" data-vv-as="GEN" type="text" class="form-control">
          </div><!-- /.form-group -->

          <div class="form-group">
            <p class="control-label">Region</p>
            <multiselect
              v-validate
              data-vv-validate-on="input|blur"
              v-model="regionSelected"
              track-by="value"
              label="text"
              name="region"
              key="region"
              :options="regionOptions"
              :searchable="false"
              :show-labels="false"
              :class="[errorClass('region'), validClass('region')]"
              placeholder=""/>
          </div><!-- /.form-group -->

          <div class="form-group">
            <label class="control-label">User Type</label>
            <p class="form-control-plaintext minimal">Graduate</p>
          </div><!-- /.form-group -->

          <div class="form-group">
            <label class="control-label">Phone</label>
            <input v-model="phone" v-validate="" name="phone" type="text" class="form-control">
          </div><!-- /.form-group -->

          <ladda-button :click="handleSaveNewGraduate" :validate="true" class="btn btn-success" data-dismiss="modal">Create User</ladda-button>
        </div><!-- /.modal-body -->
      </div>
    </div>
  </div><!-- /.modal -->
</template>

<script>
import { programComputed, programGraduateMethods } from 'vx/helpers'
import { handleServerErrors } from 'utils'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  data () {
    return {
      firstName: null,
      lastName: null,
      candidateId: null,
      email: null,
      gen: null,
      phone: null,
      region: null,
      regionOptions: [
        {
          value: 'Greater Metropolitan Sydney',
          text: 'Greater Metropolitan Sydney'
        },
        {
          value: 'NSW Central Tablelands',
          text: 'NSW Central Tablelands'
        },
        {
          value: 'NSW Hunter',
          text: 'NSW Hunter'
        },
        {
          value: 'New England',
          text: 'New England'
        },
        {
          value: 'NSW North Coast',
          text: 'NSW North Coast'
        }
      ]
    }
  },

  computed: {
    ...programComputed,

    /**
     * Get and set the selected region
     */
    regionSelected: {
      get () {
        return this.regionOptions.find(option => option.value === this.region)
      },

      set (option) {
        this.region = option.value
      }
    }
  },

  mounted () {
    window.$(this.$el).on('show.bs.modal', this.resetNewGraduate)
  },

  beforeDestroy () {
    window.$(this.$el).off('show.bs.modal', this.resetNewGraduate)
  },

  methods: {
    ...programGraduateMethods,

    async handleSaveNewGraduate () {
      try {
        let payload = {
          first_name: this.firstName,
          last_name: this.lastName,
          candidate_id: this.candidateId,
          email: this.email,
          gen: this.gen,
          phone: this.phone,
          region: this.region
        }

        await this.storeGraduate(payload)

        window.$(this.$el).modal('hide')

        this.resetNewGraduate()

        this.$noty.success('Graduate created')
      } catch (error) {
        handleServerErrors(error, this.$validator)
      }
    },

    resetNewGraduate () {
      this.firstName = null
      this.lastName = null
      this.candidateId = null
      this.email = null
      this.gen = null
      this.phone = null
      this.region = null

      this.$validator.reset()
    }
  }
}
</script>
